import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import { Spinner } from "modules/common/components";
import { livemonitorSelector } from "store/selector";
import HRNumbers from "human-readable-numbers";
import { connect } from "react-redux";
// import {
//   SummaryItem,
//   SummaryTitle,
//   SummaryCount,
//   LoaderWrapper,
//   SummaryIcon
// } from '../styles';
import { colors } from "modules/common/styles";
import {
  InsightTitle,
  LoaderWrapper,
  StatusCount,
  StatusItem,
  StatusTitle,
  TotalCallCount,
  TotalCallItem,
  TotalCallTitle,
} from "../styles/main";
import styled, { injectGlobal } from "styled-components";

const propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

injectGlobal`

  .col-total-call-item{
    &:last-child{
      .total-call-item{
        padding: 0;
      }
    }
  }

  .total-call-item {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
  }


`;

const TileContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 8px;
  padding: 10px 16px;
  // background: #f9f9f9;
  // border-radius: 10px;
`;

const Tile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #FEFEFE;
  // border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px;
  // margin-bottom: 4px !important;
`;

const TileIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 4px;
`;

const TileTitle = styled.div`
  font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 22px;
    color: #010101;
    opacity: 50%;
  
`;

const TileCount = styled.div`
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
    text-align: right;
    color: #2B3C93;
    display: flex;
    justify-content: end;
    width: 100%;
`;

class RowWrapper extends Component {
  render() {
    return (
      <Row
        style={{
          padding: "10px",
          // background: "#f9f9f9",
          // borderRadius: "10px",
          // margin: "0px 18px",
        }}
      >
        {this.props.children}
      </Row>
    );
  }
}

export class LiveMonitorTileChatMediumTheme extends Component {
  renderTileRow(image, title, number) {
    return (
      // <Col sm={5} className="col-total-call-item">
      //   <TotalCallItem className="total-call-item">
      //     <span style={{ display: "flex", alignItems: "center" }}>
      //       <img
      //         style={{ marginRight: "10px" }}
      //         src={image}
      //         className="loadImg"
      //       />
      //       <TotalCallTitle className="livetile-title">{title}</TotalCallTitle>
      //     </span>
      //     <TotalCallCount className="totalcallcount">
      //       {HRNumbers.toHumanString(number || 0)}{" "}
      //     </TotalCallCount>
      //   </TotalCallItem>
      // </Col>
      <Tile>
        <TileIcon src={image} alt={title} />
        <TileTitle>{title}</TileTitle>
        <TileCount>{HRNumbers.toHumanString(number || 0)}{" "}</TileCount>
      </Tile>
    );
  }

  renderTotalCalls(item) {
    return this.renderTileRow(item.icon, item.title, item.count);
  }

  render() {
    const { __ } = this.context;
    let { data, loading, liveChatData, forAgentDashboard } = this.props;
    if (loading) {
      return (
        <LoaderWrapper>
          <Spinner objective />
        </LoaderWrapper>
      );
    }
    if (forAgentDashboard) {
      return (
        <RowWrapper>
          {data.map((detail) => this.renderTotalCalls(detail))}
        </RowWrapper>
      );
    }

    return (
      // <RowWrapper>
      //   {this.renderTileRow(
      //     "/images/icons/whatsapp.png",
      //     "Whatsapp",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.whatsapp ? liveChatData.totalCount.whatsapp : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/instagram.png",
      //     "Instagram",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.instagram ? liveChatData.totalCount.intagram : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_outgoing_call.svg",
      //     "Facebook",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.facebook ? liveChatData.totalCount.facebook : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_total_call.svg",
      //     "RCS",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.rcs ? liveChatData.totalCount.rcs : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_inbound_call.svg",
      //     "Webchat",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.webchat ? liveChatData.totalCount.webchat : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_outgoing_call.svg",
      //     "Telegram",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.telegram ? liveChatData.totalCount.telegram : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_total_call.svg",
      //     "SMS",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.sms ? liveChatData.totalCount.sms : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_inbound_call.svg",
      //     "CPASS",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.cpass ? liveChatData.totalCount.cpass : 0
      //   )}
      //   {this.renderTileRow(
      //     "/images/icons/ic_outgoing_call.svg",
      //     "Other",
      //     liveChatData && liveChatData.totalCount && liveChatData.totalCount.other ? liveChatData.totalCount.other : 0
      //   )}
      // </RowWrapper>

      <TileContainer>
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.whatsapp ? this.renderTileRow(
          "/images/icons/WhatsApp.png",
          "WhatsApp",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.whatsapp ? liveChatData.totalCount.whatsapp : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.instagram ? this.renderTileRow(
          "/images/icons/Instagram.png",
          "Instagram",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.instagram ? liveChatData.totalCount.instagram : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.facebook ? this.renderTileRow(
          "/images/icons/Facebook.png",
          "Facebook",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.facebook ? liveChatData.totalCount.facebook : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.rcs ? this.renderTileRow(
          "/images/icons/RCS.png",
          "RCS",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.rcs ? liveChatData.totalCount.rcs : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.webchat ? this.renderTileRow(
          "/images/icons/Webchat.png",
          "Webchat",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.webchat ? liveChatData.totalCount.webchat : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.telegram ? this.renderTileRow(
          "/images/icons/Telegran.png",
          "Telegram",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.telegram ? liveChatData.totalCount.telegram : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.sms ? this.renderTileRow(
          "/images/icons/SMS.png",
          "SMS",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.sms ? liveChatData.totalCount.sms : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.cpass ? this.renderTileRow(
          "/images/icons/CPASS.png",
          "CPASS",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.cpass ? liveChatData.totalCount.cpass : 0
        ) : ""}
        {liveChatData && liveChatData.totalCount && liveChatData.totalCount.other ? this.renderTileRow(
          "/images/icons/Other.png",
          "Other",
          liveChatData && liveChatData.totalCount && liveChatData.totalCount.other ? liveChatData.totalCount.other : 0
        ) : ""}
      </TileContainer>
    );
  }
}

const stateToProps = (state) => ({
  liveChatData: livemonitorSelector.getLiveChatData(state, { key: "liveChatData" }),
  // state: livemonitorSelector.getLiveDynamic(state, { key: 'state' }),
});

const dispatchToProps = (dispatch) => ({});
export default connect(stateToProps, dispatchToProps)(LiveMonitorTileChatMediumTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorTileChatMediumTheme.js